import {
    Button,
    FormControl,
    Input,
    TableSortLabel,
    TextField,
    InputAdornment,
    MuiThemeProvider,
    Paper,
    Tooltip,
    Typography,
    withStyles
} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CreateIcon from '@material-ui/icons/Create';
import EnhancedToolbar from './EnhancedToolBar/CustomToolbar';
import cs from 'classnames';
import SearchIcon from '@material-ui/icons/Search';
import CloseIcon from '@material-ui/icons/Close';
import CustomPagination from 'components/Common/Utils/CustomPagination';
import useDebounce from 'components/TrustCenter/UI/Debounce/Debounce';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import {
    getFuelVendorAccounts,
    setSortOrder,
    setSortField,
    deleteFuelVendorAccounts,
    unSetPreviousSelectedFuelAccounts,
    setPreviousSelectedFuelAccounts,
    setSelectedFuelAccounts,
    resetFuelVendorAccount
} from 'components/FuelVendor/store/actions';
import { PRIMARY_BUTTON_LIGHT_THEME } from 'components/UI/Button/ButtonMuiTheme';
import Spinner from 'components/UI/Spinner/Spinner';
import * as Constants from 'constants/Constants';
import Auxiliary from 'hoc/Auxiliary';
import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import FuelVendorSummaryStyles from './FuelVendorSummaryStyles';
import Grid from '@material-ui/core/Grid';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { isNotEmptyObject } from 'components/Common/Utils/StringUtils';
import { SYSTEM_ADMIN, CARRIER_ADMIN } from 'constants/Constants';
import {
    MUIDATATABLE_THEME,
    MUIDATATABLE_THEME_ALT,
    SEARCH_BAR_DARK_THEME
} from 'components/FuelVendor/FuelVendorSummary/FuelVendorSummaryGridMuiTheme';
import { event } from 'components/Common/Utils/ReactGa4Utils';

const FuelVendorSummaryGrid = (props) => {
    const {
        classes,
        showSummarySpinner,
        disableOtherOperation,
        sidebarResource,
        sessionValue,
        setSortOrder,
        setSortField,
        totalElements,
        page,
        size,
        sortOrder,
        sortField,
        fuelVendorAccounts,
        getFuelVendorAccounts,
        getOrderedFuelVendorAccounts,
        unSetPreviousSelectedFuelAccounts,
        setPreviousSelectedFuelAccounts,
        setSelectedFuelAccounts,
        prevSelectedFuelAccounts,
        resetFuelVendorAccount,
        selectedAccount,
        session
    } = props;

    const [data, setData] = useState([]);

    const [searchValue, setSearchValue] = useState('');

    const [showSearch, setShowSearch] = useState(true);

    const [showSearchBar, setShowSearchBar] = useState(false);

    const debouncedSearchTerm = useDebounce(searchValue, 1000);

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const [userRole, setUserRole] = useState({
        isSystemAdmin: false,
        isCarrierAdmin: false,
        isUser: false
    });

    const [rowsSelected, setRowsSelected] = useState([]);

    const [currentAllSelectedFuelAccounts, setCurrentAllSelectedFuelAccounts] = useState([]);

    useEffect(() => {
        let allSelected = [...prevSelectedFuelAccounts, ...currentAllSelectedFuelAccounts];
        allSelected = allSelected.reduce((unique, o) => {
            if (!unique.some((obj) => obj.id === o.id)) {
                unique.push(o);
            }
            return unique;
        }, []);
        let rowSelected = [];
        allSelected.forEach((value, index) => {
            fuelVendorAccounts.forEach((value1, index2) => {
                if (value1.id === value.id) {
                    rowSelected.push(index2);
                }
            });
        });
        setRowsSelected(rowSelected);
    }, [currentAllSelectedFuelAccounts, fuelVendorAccounts, prevSelectedFuelAccounts]);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.FUELVENDOR_RESOURCE,
                Constants.FUELVENDOR_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        setSortField('account_code');
        setSortOrder('asc');
        getFuelVendorAccounts(1, size, 'asc', 'account_code');
    }, [getFuelVendorAccounts]);

    useEffect(() => {
        setUserRole({
            ...userRole,
            isSystemAdmin: sessionValue.userRole === SYSTEM_ADMIN,
            isCarrierAdmin: sessionValue.userRole === CARRIER_ADMIN,
            isUser: sessionValue.isUser
        });
    }, [sessionValue.userRole]);

    useEffect(() => {
        setData(formulateDataGrid(fuelVendorAccounts));
    }, [fuelVendorAccounts]);

    const clearSearch = (searchBarFlag, resetData = false) => {
        if (searchBarFlag) {
            setShowSearch(true);
            setSearchValue('');
            if (resetData) {
                getFuelVendorAccounts(1, size, sortOrder, sortField);
            }
            setShowSearchBar(false);
        } else if (showSearchBar) {
            getFuelVendorAccounts(1, size, sortOrder, sortField);
        }
    };

    const toggleSearch = () => {
        setShowSearchBar(true);
        setShowSearch(false);
    };

    useEffect(() => {
        if (debouncedSearchTerm === '') {
            clearSearch(false);
        } else {
            const debouncedSearchTermTrimmed = debouncedSearchTerm.trim();
            getFuelVendorAccounts(1, size, sortOrder, sortField, debouncedSearchTermTrimmed);
        }
    }, [debouncedSearchTerm]);

    const handleSearch = (event) => {
        const searchVal = event.target.value;
        setCurrentAllSelectedFuelAccounts([]);
        setSearchValue(searchVal);
    };

    const handleSort = (selectedField) => {
        var order;
        if (sortField !== selectedField) {
            setSortField(selectedField);
            order = 'asc';
        } else {
            order = sortOrder === 'asc' ? 'desc' : 'asc';
        }
        setSortOrder(order);
        setCurrentAllSelectedFuelAccounts([]);
        getFuelVendorAccounts(page, size, order, selectedField, searchValue);
    };

    const createNewAccount = () => {
        event('Add FuelPartner', 'ClickFuelPartnerButton', `${session.accountName}`);
        const fuelVendorDetailsPath = `/fuelcard-details`;
        resetFuelVendorAccount({});
        props.history.push(fuelVendorDetailsPath);
    };

    const onClickEdit = (selectedVendorId) => {
        fuelVendorDetailsHandler(selectedVendorId, Constants.FUEL_EDIT_MODE);
    };

    const fuelVendorDetailsHandler = (id, mode) => {
        let fuelVendorDetailsPath = `/fuelcard-details/${id}`;
        if (mode === Constants.FUEL_EDIT_MODE) {
            fuelVendorDetailsPath = `/fuelcard-details/${id}/${mode}`;
        }
        if (userRole.isSystemAdmin) {
            fuelVendorDetailsPath = `/fuelcard-details/${id}?accountId=${selectedAccount.id}`;
        }
        props.history.push(fuelVendorDetailsPath);
    };

    const ellipsis = (data, length) => {
        if (data !== null) {
            return data.length < length ? data : data.substring(0, length) + ' ...';
        }
    };

    const formulateDataGrid = (data) => {
        let filteredResult = [];
        if (isNotEmptyObject(data) && data.length > 0) {
            data.map((row) => {
                const accountCodeId = {
                    id: row.id,
                    accountCode: row.account_code
                };
                const customerCode = row.customer_code;
                const vendorName = row.vendor_name;
                const type = row.vendor_type;
                const status = row.status;
                const userName = row.user_name;
                const password = row.password + '~*%' + false + '~*%' + 'mask password';
                const id = row.id;
                const filteredRow = [
                    accountCodeId,
                    customerCode,
                    vendorName,
                    type,
                    status,
                    userName,
                    password,
                    id
                ];
                return filteredResult.push(filteredRow);
            });
        }
        return filteredResult;
    };

    const columns = [
        {
            name: 'AccountCode',
            options: {
                customHeadRender: () => {
                    return (
                        <th
                            className={classes.tableHeader}
                            onClick={() => handleSort('account_code')}
                            key={'AccountCode'}
                        >
                            {'Account Code'}
                            <TableSortLabel
                                className={classes.inline}
                                active={sortField === 'account_code'}
                                direction={sortOrder}
                            />
                        </th>
                    );
                },
                customBodyRender: (value) => {
                    return (
                        <Tooltip title={'Navigate to Fuel Card Partners Details'}>
                            <Typography
                                variant={'subtitle1'}
                                className={classes.accountName}
                                id={'fuelVendorAccount_' + value.accountCode}
                                date-connection-id={value.id}
                            >
                                {ellipsis(value.accountCode, 15)}
                            </Typography>
                        </Tooltip>
                    );
                }
            }
        },
        {
            name: 'CustomerCode',
            options: {
                customHeadRender: () => {
                    return (
                        <th
                            className={classes.tableHeader}
                            onClick={() => handleSort('customer_code')}
                            key={'CustomerCode'}
                        >
                            {'Customer Code'}
                            <TableSortLabel
                                className={classes.inline}
                                active={sortField === 'customer_code'}
                                direction={sortOrder}
                            />
                        </th>
                    );
                },
                customBodyRender: (value) => {
                    return <Typography id={'customerCode'}> {ellipsis(value, 20)}</Typography>;
                }
            }
        },
        {
            name: 'Vendor',
            options: {
                customHeadRender: () => {
                    return (
                        <th
                            className={classes.tableHeader}
                            onClick={() => handleSort('vendor_name')}
                            key={'Vendor'}
                        >
                            {'Vendor'}
                            <TableSortLabel
                                className={classes.inline}
                                active={sortField === 'vendor_name'}
                                direction={sortOrder}
                            />
                        </th>
                    );
                },
                customBodyRender: (value) => {
                    return <Typography id={'vendorName'}> {ellipsis(value, 20)}</Typography>;
                }
            }
        },

        {
            name: 'Type',
            options: {
                customHeadRender: () => {
                    return (
                        <th
                            className={classes.tableHeader}
                            onClick={() => handleSort('vendor_type')}
                            key={'Type'}
                        >
                            {'Type'}
                            <TableSortLabel
                                className={classes.inline}
                                active={sortField === 'vendor_type'}
                                direction={sortOrder}
                            />
                        </th>
                    );
                },
                customBodyRender: (value) => {
                    return <Typography id={'type'}> {ellipsis(value, 20)}</Typography>;
                }
            }
        },
        {
            name: 'Status',
            options: {
                sort: false,
                customHeadRender: () => {
                    return <th className={classes.tableHeader}>{'Status'}</th>;
                },
                customBodyRender: (value) => {
                    return <Typography id={'status'}> {value ? 'Active' : 'Inactive'} </Typography>;
                }
            }
        },
        {
            name: 'UserName',
            options: {
                customHeadRender: () => {
                    return <th className={classes.tableHeader}>{'User Name'}</th>;
                },
                customBodyRender: (value) => {
                    return <Typography id={'userName'}> {ellipsis(value, 20)}</Typography>;
                }
            }
        },
        {
            name: 'Password',
            options: {
                customHeadRender: () => {
                    return <th className={classes.tableHeader}>{'Password'}</th>;
                },
                customBodyRender: (value, tableMeta, updateValue) => {
                    const splitVal = value.split('~*%');
                    const pass = JSON.parse(splitVal[1]);
                    const value1 = splitVal[0];
                    const sampleValue = splitVal[2];

                    return (
                        <FormControl>
                            <Input
                                style={{ width: 200 }}
                                id="password"
                                type={pass ? 'text' : 'password'}
                                value={pass ? ellipsis(value1, 20) : sampleValue}
                                disabled
                                endAdornment={
                                    <InputAdornment position="start">
                                        <Tooltip title={'Show/Hide'}>
                                            <IconButton
                                                id={'show-hide-password'}
                                                aria-label="Toggle password visibility"
                                                onClick={(event) =>
                                                    updateValue(
                                                        value1 + '~*%' + !pass + '~*%' + sampleValue
                                                    )
                                                }
                                            >
                                                {pass ? <Visibility /> : <VisibilityOff />}
                                            </IconButton>
                                        </Tooltip>
                                    </InputAdornment>
                                }
                            />
                        </FormControl>
                    );
                }
            }
        },
        {
            name: 'Actions',
            options: {
                customHeadRender: () => {
                    return (
                        <th className={classes.tableHeader} key={'Actions'}>
                            {'Actions'}
                        </th>
                    );
                },
                sort: false,
                customBodyRender: (value) => {
                    return (
                        <div>
                            <Tooltip title={'Edit'} id={'Edit'}>
                                <IconButton
                                    id={'EditIcon'}
                                    disabled={!isWriteAccessGranted}
                                    onClick={() => onClickEdit(value)}
                                >
                                    <CreateIcon />
                                </IconButton>
                            </Tooltip>
                        </div>
                    );
                }
            }
        }
    ];

    const options = {
        textLabels: {
            body: {
                noMatch: 'No record found'
            },
            selectedRows: {
                text: 'Fuel card partner(s) selected'
            }
        },
        filter: false,
        download: false,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: !userRole.isSystemAdmin && isWriteAccessGranted ? 'multiple' : 'none',

        onCellClick: (cellData, cellMeta) => {
            const { colIndex } = cellMeta;
            let id = '';
            if (colIndex === 0) {
                id = cellData.props.children.props['date-connection-id'];
                fuelVendorDetailsHandler(id, Constants.FUEL_VIEW_MODE);
            } else {
                return null;
            }
        },
        page: page - 1,
        serverSide: true,
        count: totalElements,
        rowsSelected: rowsSelected,
        sort: false,
        rowsPerPage: size,
        print: false,
        search: false,
        viewColumns: false,
        expandableRows: false,
        rowsPerPageOptions: [5, 10, 20],
        onChangeRowsPerPage: (numberOfRows) => {
            let pageNo = 0;
            if (page === 1 || numberOfRows >= totalElements) {
                pageNo = 1;
            } else {
                let newPage;
                if (size < numberOfRows) {
                    newPage = Math.ceil((page * size) / numberOfRows);
                    pageNo = newPage === 0 ? 1 : newPage;
                } else {
                    newPage = Math.ceil(((page - 1) * size) / numberOfRows);
                    pageNo = newPage === 0 ? 1 : newPage + 1;
                }
            }
            getFuelVendorAccounts(pageNo, numberOfRows, sortOrder, sortField, searchValue);
        },
        onChangePage: (currentPage) => {
            const cPage = currentPage + 1;
            setPreviousSelectedFuelAccounts();
            setCurrentAllSelectedFuelAccounts([]);
            unSetPreviousSelectedFuelAccounts(null, 'all');
            getFuelVendorAccounts(cPage, size, sortOrder, sortField, searchValue);
        },

        customFooter: (count, page, rowsPerPage, changeRowsPerPage, onChangePage, textLabels) => {
            return (
                <CustomPagination
                    count={count}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    changeRowsPerPage={changeRowsPerPage}
                    onChangePage={onChangePage}
                    textLabels={textLabels}
                />
            );
        },

        customToolbar: () => {
            return (
                <React.Fragment>
                    <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_THEME}>
                        {showSearch ? (
                            <Tooltip title={'Search'}>
                                <IconButton
                                    className={classes.iconButton}
                                    id={'data-table-search'}
                                    onClick={() => toggleSearch()}
                                >
                                    <SearchIcon className={classes.searchIconDark} />
                                </IconButton>
                            </Tooltip>
                        ) : null}
                        {showSearchBar ? (
                            <React.Fragment>
                                <MuiThemeProvider theme={SEARCH_BAR_DARK_THEME}>
                                    <TextField
                                        className={classes.searchBarDark}
                                        value={searchValue}
                                        id="data-table-search-input"
                                        autoFocus
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <CloseIcon
                                                        id={'closeIcon'}
                                                        className={classes.closeIconDar}
                                                        onClick={() => clearSearch(true, true)}
                                                    />
                                                </InputAdornment>
                                            )
                                        }}
                                        onChange={handleSearch}
                                    />
                                </MuiThemeProvider>
                            </React.Fragment>
                        ) : null}

                        {!userRole.isSystemAdmin && (
                            <Button
                                id={'newFuelVendorCard'}
                                onClick={createNewAccount}
                                disabled={disableOtherOperation || !isWriteAccessGranted}
                                className={classes.addFuelVendorButton}
                            >
                                ADD FUEL PARTNER
                            </Button>
                        )}
                    </MuiThemeProvider>
                </React.Fragment>
            );
        },
        onRowSelectionChange: (currentRowsSelected, all) => {
            const allSelectedFuelAccounts =
                all.length > 0 ? all.map(({ index }) => fuelVendorAccounts[index]) : [];
            setCurrentAllSelectedFuelAccounts(allSelectedFuelAccounts);
            if (allSelectedFuelAccounts.length === 0) {
                unSetPreviousSelectedFuelAccounts(null, 'all');
            } else {
                setSelectedFuelAccounts([...allSelectedFuelAccounts]);
            }
            if (currentRowsSelected.length > 0) {
                const checkIndex = currentRowsSelected[0].index;
                const unselectedValue = !all.some((el) => el.index === checkIndex)
                    ? fuelVendorAccounts[checkIndex]
                    : null;
                if (unselectedValue !== null) {
                    unSetPreviousSelectedFuelAccounts([unselectedValue.id], 'multiple');
                }
            }
        },
        customToolbarSelect: (selectedRows) => {
            return (
                <EnhancedToolbar
                    selectedFuelAccountsDataIndexes={selectedRows}
                    fuelVendorAccounts={fuelVendorAccounts}
                    setRowsSelected={setRowsSelected}
                    setCurrentAllSelectedFuelAccounts={setCurrentAllSelectedFuelAccounts}
                />
            );
        }
    };

    return (
        <React.Fragment>
            <Auxiliary>
                <Paper className={classes.vcPaper}>
                    <Auxiliary>
                        <MuiThemeProvider
                            theme={
                                !userRole.isSystemAdmin
                                    ? MUIDATATABLE_THEME
                                    : MUIDATATABLE_THEME_ALT
                            }
                        >
                            {!showSummarySpinner && Object.entries(sessionValue).length > 0 ? (
                                <MUIDataTable
                                    id={'vc_grid'}
                                    title={
                                        <Grid container>
                                            <Grid item>
                                                <label
                                                    id={'pageTitle'}
                                                    className={cs(
                                                        classes.titleBar,
                                                        userRole.isSystemAdmin &&
                                                            classes.titleBarAlt
                                                    )}
                                                >
                                                    {'FUEL CARD PARTNERS'}
                                                </label>
                                            </Grid>
                                        </Grid>
                                    }
                                    data={data}
                                    columns={columns}
                                    options={options}
                                />
                            ) : (
                                <Spinner />
                            )}
                        </MuiThemeProvider>
                    </Auxiliary>
                </Paper>
            </Auxiliary>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => ({
    sortOrder: state.fuelVendor.sortOrder,
    sortField: state.fuelVendor.sortField,
    totalElements: state.fuelVendor.totalElements,
    size: state.fuelVendor.pageSize,
    page: state.fuelVendor.page,
    showSummarySpinner: state.fuelVendor.showSummarySpinner,
    sidebarResource: state.header.sidebarResource,
    fuelVendorAccounts: state.fuelVendor.fuelVendorAccounts,
    selectedFuelAccounts: state.fuelVendor.selectedFuelAccounts,
    prevSelectedFuelAccounts: state.fuelVendor.prevSelectedFuelAccounts,
    selectedAccount: state.accounts.selectedAccount,
    session: state.session.sessionValue
});

export default withRouter(
    connect(mapStateToProps, {
        getFuelVendorAccounts,
        setSortOrder,
        setSortField,
        deleteFuelVendorAccounts,
        validateWriteAccess,
        unSetPreviousSelectedFuelAccounts,
        setPreviousSelectedFuelAccounts,
        setSelectedFuelAccounts,
        resetFuelVendorAccount
    })(withStyles(FuelVendorSummaryStyles)(FuelVendorSummaryGrid))
);
